import { SampleDetailsDTO } from './../ngs-work-list/model/sample-details-dto';
import { MachineGeneratedFile } from './../ngs-volume-adjustment/machine-generated-file';
import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { timeout, tap } from 'rxjs/operators';
import { LibQCFAWorkFileRequest } from './model/lib-qc-fa-workfile-request';
import { BBResponseContainer } from '../common-services/response-container';

@Injectable()
export class NGSLibraryQCService {
    
    constructor(private http: HttpClient) {
    }

    getPlateViewFromFLXFile(flxFile: MachineGeneratedFile): Observable<BBResponseContainer> {
        let url = environment.BB_NGS_LIB_PREP_URL + 'libqc/platedata';
        return this.http.post<BBResponseContainer>(url, flxFile).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
          }));
    }

    saveAssayTypeChanges(changedSamples: SampleDetailsDTO[]): Observable<BBResponseContainer> {
        let url = environment.BB_NGS_LIB_PREP_URL + 'libqc/assaytype';
        return this.http.put<BBResponseContainer>(url, changedSamples).pipe(timeout(environment.defaultTimeout),tap(event => {}, error => {
            error.url = url;
        }))
    }

    generateLibQCFAWorkfiles(libQCFAWorkFileRequest: LibQCFAWorkFileRequest): Observable<BBResponseContainer> {
        let url = environment.BB_NGS_LIB_PREP_URL + '/libqc/fa/generateFAWorkFiles';
        return this.http.post<BBResponseContainer>(url, libQCFAWorkFileRequest).pipe(timeout(environment.defaultTimeout),tap(event => {}, error => {
            error.url = url;
        }))
    }

    saveTagsExcel(formData: FormData) {
        let url = environment.BB_NGS_LIB_PREP_URL + "/libprep/tagSystem/upload";
        return this.http.post<any>(url, formData).pipe(timeout(environment.defaultTimeout), tap( error => {
            error.url = url;
        }));
        }

  
}